import { GetOrganizationDashboardQuery } from "@therapprove/common";

export type DashboardMetrics = NonNullable<
    NonNullable<
        GetOrganizationDashboardQuery["organizations"]
    >["organizationDashboard"]
>;

export type DashboardDateRange = [Date | null, Date | null];

export type DashboardDateShortcut = {
    label: string;
    getValue: () => DashboardDateRange;
};

export type DashboardActionItem = {
    label: string;
    hint: string;
    count: number;
    path: string;
};

export type SummaryMetricCard = {
    label: string;
    hint: string;
    accent: "primary" | "secondary" | "violet";
    value?: number;
};

export const EMPTY_DASHBOARD_METRICS: DashboardMetrics = {
    referralPipelineCount: 0,
    pipelineReferralsWithoutAssignedProviderCount: 0,
    inboundTriageCount: 0,
    staleReferralPipelineCount: 0,
    globalReferralInvitePendingCount: 0,
    directReferralCount: 0,
    directReferralsReceivedCount: 0,
    websiteLeadCount: 0,
    websiteLeadsMovedToPipelineCount: 0,
    pendingInviteCount: 0
};
